const invoice = [
  {
    path: "/create-invoice/:orderNum",
    name: "/create-invoice/orderNum",
    component: () => import("@/views/CreateInvoicePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "EmptyHeader",
      title: "Create Invoice",
    },
  },

  {
    path: "/invoice-success",
    name: "/invoice-success",
    component: () => import("@/views/InvoiceSuccessPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "EmptyHeader",
      title: "Successfully",
    },
  },
];

export { invoice };
